/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Directive, HostListener, Input } from '@angular/core';

/**
 * @export
 * @class StickyDirective
 */
@Directive({
  selector: '[lmsSticky]'
})

export class StickyDirective {


  private minY = 67;
  private className = 'stick';

  @Input('stickMin') set stickMin(minY: number) {
    this.minY = minY || this.minY;
  }

  @Input('stickClass') set stickClass(className: string) {
    this.className = className || this.className;
  }

  /**
   * Creates an instance of StickyDirective.
   * @memberOf StickyDirective
   */
  constructor() {

  }

  /**
   * @private
   * @memberOf StickyDirective
   */
  private scrollToTop() {
    const scrollDuration = 36;
    const scrollStep = -window.scrollY / (scrollDuration / 15),
      scrollInterval = setInterval(function () {
        if (window.scrollY !== 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval);
        };
      }, 15);
  }

  /**
   * @memberOf StickyDirective
   */
  @HostListener('window:scroll', [])
  handleScrollEvent() {
    const leftMenuItem = document.getElementById('leftMenuItems');
    const topHeader = document.getElementById('top-actions');
    const pageWrapper = document.getElementById('pageDetails');
    const top = (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let heightToAdjust = 0;
    if (window.innerWidth < 1280) {
        heightToAdjust = 22;
    }
    if (top > this.minY) {
      leftMenuItem.classList.add(this.className);
      if (topHeader) {
        topHeader.classList.add(this.className);
      }
      leftMenuItem.removeAttribute('style');
      leftMenuItem.style.maxHeight = (window.innerHeight) + 'px';
      leftMenuItem.style.minHeight = (window.innerHeight - heightToAdjust) + 'px';
      pageWrapper.style.paddingTop = this.minY + 'px';

    } else {
      leftMenuItem.classList.remove(this.className);
       leftMenuItem.style.minHeight = (window.innerHeight - 36 - heightToAdjust) + 'px';
      if (topHeader) {
        topHeader.classList.remove(this.className);
      }
      pageWrapper.removeAttribute('style');
    }
  }
}
